var React = require('react');

function Menuburger (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Shape"),React.createElement("g",{"id":"Icons","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Icon-/-Menu","transform":"translate(-3.000000, -6.000000)","fill":"#FFF"},React.createElement("path",{"d":"M3,18 L21,18 L21,16 L3,16 L3,18 Z M3,13 L17,13 L17,11 L3,11 L3,13 Z M3,6 L3,8 L21,8 L21,6 L3,6 Z","id":"Shape"})))]);
}

Menuburger.defaultProps = {"width":"18px","height":"12px","viewBox":"0 0 18 12","version":"1.1"};

module.exports = Menuburger;

Menuburger.default = Menuburger;
